import { render, staticRenderFns } from "./car-benefits.vue?vue&type=template&id=13d3f20d"
import script from "./car-benefits.vue?vue&type=script&lang=js"
export * from "./car-benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports